exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trans_phone_number {\n\tborder-radius: 0 4px 4px 0;\n}\n", ""]);

// exports
